import { CheckVerified02FilledIcon } from 'src/shared/icons/check-verified-02-filled-icon'
import { css, styled } from 'styled-components'
import { FormInterface } from '../form.schema'

export interface FormSuccessOptInScreenIconUiStylesInterface
  extends Pick<
    FormInterface['action']['successOptInScreen'],
    'iconColor' | 'mobileIconColor'
  > {}

export const FormSuccessOptInScreenIconUi = styled(
  CheckVerified02FilledIcon,
)<FormSuccessOptInScreenIconUiStylesInterface>`

  width: 56px;
  height: 56px;

  & path {
    ${p => p.iconColor && `fill: ${p.iconColor};`}
  }

  ${p => p.theme.phone} {
    & path {
      ${p => p.mobileIconColor && `fill: ${p.mobileIconColor};`}
    }
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      & path {
        ${p.mobileIconColor && `fill: ${p.mobileIconColor};`}
      }
  `}
`
